<mbs-wizard
  class="mbs-wizard_flex-content"
  [buttonLoadingMode]="true"
  [canClosed]="!loadingPlan && wizardFinish"
  [firstStepTitle]="mainService.firstStepTitle"
  [isOpenSteps]="!loadingPlan && isEdit"
  [loading]="loadingPlan"
  [scrollableStepContent]="true"
  [stepQueue]="stepsManager.stepQueue"
  [stepsContainerClass]="mainService.isOffline ? 'overflow-hidden' : ''"
  [stepsOrientation]="orientations"
  [title]="wizardTitle + ' ' + mainService.compName + ' | ' + (FormModel?.planNameStep?.Name || '')"
  [(ngModel)]="stepsManager.currentStep"
  (closeModalEvent)="handleModalClose()"
  (next)="nextHandler($event)"
  (save)="handleSave()"
  (stepSelected)="stepSelectedHandler($event)">
  <div
    *ngIf="mainService.isOffline"
    class="pl-4 py-2 background-secondary"
    prependStep>
    <span class="fa fa-power-off"></span> {{ prependStepText }}
  </div>

  <mbs-wizard-step
    [documentationLink]="helpLink.links.welcome"
    [title]="'wizards:welcome' | i18next"
    [valid]="FormModel?.planNameStep?.valid"
    (next)="planNameStep?.forceValid()">
    <mbs-plan-name-step
      #planNameStep
      [planTypeText]="planTypeText"
      [(ngModel)]="FormModel.planNameStep"
      (copyPlan)="handleCopyRAWPlan()"
      (restoreOnce)="restoreOnceHandler($event)"></mbs-plan-name-step>
  </mbs-wizard-step>
  <mbs-wizard-step
    [documentationLink]="helpLink.links.storage"
    [title]="'wizards:whereBackup.where_backup_title' | i18next"
    [valid]="FormModel?.whereBackupStep?.valid"
    (next)="whereBackupStep?.forceValid()">
    <mbs-where-backup-step
      #whereBackupStep
      [Storages]="FormModel?.Storages"
      [(ngModel)]="FormModel.whereBackupStep"
      (changeStorage)="storageManager.changeStorageHandler($event)"></mbs-where-backup-step>
  </mbs-wizard-step>

  <mbs-wizard-step
    [documentationLink]="helpLink.links.selectComputer"
    [title]="'wizards:computers_to_restore_title' | i18next"
    [valid]="FormModel?.computerToRestoreStep?.valid"
    (next)="computerToRestore?.forceValid()">
    <mbs-select-computer-step
      #computerToRestore
      [stepFocused]="stepsManager.currentStep?.title === ('wizards:computers_to_restore_title' | i18next)"
      [storageId]="FormModel?.whereBackupStep?.ConnectionID"
      [(ngModel)]="FormModel.computerToRestoreStep"
      (loadInfo)="loadInfoHandler($event)"></mbs-select-computer-step>
  </mbs-wizard-step>

  <mbs-wizard-step
    [documentationLink]="helpLink.links.selectBackup"
    [title]="'wizards:backupToRestoreTitle' | i18next"
    [valid]="FormModel?.backupToRestoreStep?.valid"
    (next)="backupToRestore?.forceValid()">
    <mbs-backup-to-restore-step
      #backupToRestore
      [computerName]="FormModel?.computerToRestoreStep?.computerName"
      [storageId]="FormModel?.whereBackupStep?.ConnectionID"
      [(ngModel)]="FormModel.backupToRestoreStep"
      (loadInfo)="loadInfoHandler($event)"></mbs-backup-to-restore-step>
  </mbs-wizard-step>

  <mbs-wizard-step
    [documentationLink]="helpLink.links.selectPoint"
    [title]="restorePointTitle"
    [valid]="FormModel?.restorePointStep?.valid"
    (next)="restorePointStep?.forceValid(stepsManager.currentStep)">
    <mbs-restore-point-step
      #restorePointStep
      [bunchId]="FormModel?.backupToRestoreStep?.selectedBunch"
      [computerName]="FormModel?.computerToRestoreStep?.computerName"
      [storageId]="FormModel?.whereBackupStep?.ConnectionID"
      [(ngModel)]="FormModel.restorePointStep"
      (loadInfo)="loadInfoHandler($event)"
      (nextStep)="forceNextStepWizard(!!$event, 'restorePointStep', restorePointTitle)"></mbs-restore-point-step>
  </mbs-wizard-step>
  <mbs-wizard-step
    [documentationLink]="helpLink.links.typeOfData"
    [title]="'wizards:typeData.title' | i18next"
    [valid]="FormModel?.typeDataStep?.valid"
    (next)="typeDataStep?.forceValid(stepsManager.currentStep)">
    <mbs-type-data-step
      #typeDataStep
      [fileFormats]="FormModel.fileFormats"
      [(ngModel)]="FormModel.typeDataStep"
      (restoreAsChange)="restoreAsChangeHandler($event)"></mbs-type-data-step>
  </mbs-wizard-step>

  @if (!isInstantRestore()) {
    <mbs-wizard-step
      [documentationLink]="helpLink.links.partitions"
      [title]="partitionsTitle"
      [valid]="FormModel?.partitionsStep?.valid"
      (next)="partitionsStep?.forceValid()">
      <mbs-partitions-step
        #partitionsStep
        [bunchId]="FormModel?.backupToRestoreStep?.selectedBunch"
        [computerName]="FormModel?.computerToRestoreStep?.computerName"
        [restoreAs]="FormModel?.typeDataStep?.restoreAs"
        [resultPoint]="FormModel?.restorePointStep?.resultPoint"
        [selectedFileFormat]="FormModel?.typeDataStep?.selectedFileFormat"
        [storageId]="FormModel?.whereBackupStep?.ConnectionID"
        [(ngModel)]="FormModel.partitionsStep"
        (loadInfo)="loadInfoHandler($event)"
        (nextStep)="forceNextStepWizard(!!$event, 'partitionsStep', partitionsTitle)"></mbs-partitions-step>
    </mbs-wizard-step>
  }

  @if (showSelectHostStep()) {
    <mbs-wizard-step
      [documentationLink]="helpLink.links.host"
      [title]="hostTitle"
      [valid]="FormModel?.selectHostStep?.valid"
      (next)="selectHostStep?.forceValid(stepsManager.currentStep)">
      <mbs-select-host-step
        #selectHostStep
        [restoreAs]="FormModel?.typeDataStep?.restoreAs"
        [(ngModel)]="FormModel.selectHostStep"
        (loadInfo)="loadInfoHandler($event)"
        (nextStep)="forceNextStepWizard(!!$event, 'selectHostStep', hostTitle)"></mbs-select-host-step>
    </mbs-wizard-step>
  }

  @if (showVmSettingsStep()) {
    @let titleText =
      FormModel?.typeDataStep?.restoreAs === restoreAsDiskEnum.InstantRestoreToDRServer
        ? vmSettingsDRTitle
        : FormModel?.typeDataStep?.restoreAs === restoreAsDiskEnum.RestoreToVMwareVSphere
          ? vmWareSettingsTitle
          : FormModel?.typeDataStep?.restoreAs === restoreAsDiskEnum.RestoreToProxmox ||
              FormModel?.typeDataStep?.restoreAs === restoreAsDiskEnum.InstantRestoreToProxmox
            ? vmSettingsProxmoxTitle
            : vmHyperVSettingsTitle;

    <mbs-wizard-step
      [documentationLink]="helpLinkForSettingsStep()"
      [title]="titleText"
      [valid]="FormModel?.vmSettingsStep?.valid"
      (next)="vmSettingsStep?.forceValid(stepsManager.currentStep)">
      <mbs-vm-settings-step
        #vmSettingsStep
        [drServerHid]="FormModel?.typeDataStep?.drServerComputer?.hid"
        [restoreAs]="FormModel?.typeDataStep?.restoreAs"
        [restorePartitions]="FormModel?.partitionsStep?.restorePartitions"
        [(value)]="FormModel.vmSettingsStep"
        (loadInfo)="loadInfoHandler($event)"
        (nextStep)="forceNextStepWizard(!!$event, 'vmSettingsStep', titleText)"></mbs-vm-settings-step>
    </mbs-wizard-step>
  } @else if (showRestoreToCloudSteps()) {
    @if (isEC2()) {
      <mbs-wizard-step
        [title]="'wizards:targetInstanceTitle' | i18next"
        [valid]="FormModel?.targetInstanceStep?.valid"
        (next)="targetInstanceStep?.forceValid()">
        <mbs-ec2-instance-step
          #targetInstanceStep
          [isTemporary]="false"
          [(value)]="FormModel.targetInstanceStep"></mbs-ec2-instance-step>
      </mbs-wizard-step>
      <mbs-wizard-step
        [title]="'wizards:temporaryInstanceTitle' | i18next"
        [valid]="FormModel?.temporaryInstanceStep?.valid"
        (next)="temporaryInstanceStep?.forceValid()">
        <mbs-ec2-instance-step
          #temporaryInstanceStep
          [isTemporary]="true"
          [(value)]="FormModel.temporaryInstanceStep"></mbs-ec2-instance-step>
      </mbs-wizard-step>
    } @else {
      <mbs-wizard-step
        [title]="'wizards:targetInstanceTitle' | i18next"
        [valid]="FormModel?.targetInstanceAzureStep?.valid"
        (next)="targetInstanceAzureStep?.forceValid()">
        <mbs-azure-instance-step
          #targetInstanceAzureStep
          [isTemporary]="false"
          [prefixName]="FormModel?.computerToRestoreStep?.computerName"
          [(value)]="FormModel.targetInstanceAzureStep"></mbs-azure-instance-step>
      </mbs-wizard-step>
      <mbs-wizard-step
        [title]="'wizards:temporaryInstanceTitle' | i18next"
        [valid]="FormModel?.temporaryInstanceAzureStep?.valid"
        (next)="temporaryInstanceAzureStep?.forceValid()">
        <mbs-azure-instance-step
          #temporaryInstanceAzureStep
          [isTemporary]="true"
          [(value)]="FormModel.temporaryInstanceAzureStep"></mbs-azure-instance-step>
      </mbs-wizard-step>
    }
  } @else {
    @if (isEdit ? FormModel?.partitionsStep?.restorePartitions?.length : true) {
      <mbs-wizard-step
        [documentationLink]="helpLink.links.destination"
        [title]="'wizards:destinationOld.dest_step_title' | i18next"
        [valid]="FormModel?.destinationStep?.valid"
        (next)="destinationStep?.forceValid()">
        <mbs-destination-step
          #destinationStep
          [diskInfo]="FormModel?.diskItems"
          [isCurrentComputer]="FormModel?.computerToRestoreStep?.isCurrent"
          [isVirtual]="FormModel?.typeDataStep?.restoreAs === restoreAsDiskEnum.Virtual"
          [partitions]="FormModel.partitions"
          [restorePartitions]="FormModel?.partitionsStep?.restorePartitions"
          [(ngModel)]="FormModel.destinationStep"></mbs-destination-step>
      </mbs-wizard-step>
    }
  }

  <mbs-wizard-step
    *ngIf="!isNBF || FormModel?.restorePointStep?.resultPoint?.IsEncrypted || FormModel?.restorePointStep?.resultPoint?.isEncrypted"
    [documentationLink]="helpLink.links.encryption"
    [title]="stepsManager.titles.encryptionOption"
    [valid]="FormModel?.encryptionOptionsStep?.valid"
    (next)="encryptionOptionsStep?.forceValid(stepsManager.currentStep)">
    <mbs-encryption-options-step
      #encryptionOptionsStep
      [backupToRestore]="FormModel?.backupToRestoreStep?.selectedBunch"
      [resultPoint]="FormModel?.restorePointStep?.resultPoint"
      [(ngModel)]="FormModel.encryptionOptionsStep"
      (loadInfo)="loadInfoHandler($event)"
      (nextStep)="
        forceNextStepWizard(!!$event, 'encryptionOptionsStep', stepsManager.titles.encryptionOption)
      "></mbs-encryption-options-step>
  </mbs-wizard-step>

  @if (!isInstantRestore() && !showRestoreToCloudSteps()) {
    <mbs-wizard-step
      *ngIf="FormModel.planNameStep.SavePlanInCloud"
      [documentationLink]="helpLink.links.schedule"
      [title]="stepsManager.titles.schedule"
      [valid]="FormModel?.scheduleStep?.valid"
      (next)="scheduleStep?.forceValid(stepsManager.currentStep)">
      <mbs-schedule-step
        #scheduleStep
        [isGFSMode]="isGFSMode"
        [retentionTitle]="stepsManager.titles.retention"
        [stepFocused]="stepsManager.currentStep?.title === stepsManager.titles.schedule"
        [(ngModel)]="FormModel.scheduleStep"
        (changeType)="scheduleTypeChangeHandler($event)"
        (nextStep)="forceNextStepWizard(!!$event, 'scheduleStep', stepsManager.titles.schedule)"
        (registerRequiredStep)="stepsManager.stepQueue.registerRequiredStep($event)"
        (unregisterRequiredStep)="stepsManager.stepQueue.unregisterRequiredStep($event)"></mbs-schedule-step>
    </mbs-wizard-step>
    <mbs-wizard-step
      *ngIf="FormModel?.scheduleStep?.ScheduleType === 'recurring'"
      [documentationLink]="helpLink.links.schedule"
      [title]="'wizards:advanced_schedule_restore_title' | i18next"
      [valid]="FormModel.scheduleAdvancedStep.valid"
      (next)="scheduleAdvancedStep?.forceValid()">
      <mbs-schedule-advanced-step
        #scheduleAdvancedStep
        [(ngModel)]="FormModel.scheduleAdvancedStep"></mbs-schedule-advanced-step>
    </mbs-wizard-step>
    <mbs-wizard-step
      *ngIf="mainService.allowPrePostActions | async"
      [documentationLink]="helpLink.links.prePost"
      [title]="
        (mainService.allowPrePostActions | async) ? ('wizards:pre_post_title' | i18next) : ('wizards:pre_post_title_backup_chain' | i18next)
      "
      [valid]="FormModel?.prePostActionsStep?.valid"
      (next)="prePostActionsStep?.forceValid()">
      <mbs-pre-post-actions-step
        #prePostActionsStep
        [ChainPlans]="FormModel?.AvailableMachinePlans"
        [(ngModel)]="FormModel.prePostActionsStep"></mbs-pre-post-actions-step>
    </mbs-wizard-step>
    <mbs-wizard-step
      *ngIf="!isRDMode"
      [documentationLink]="helpLink.links.notification"
      [title]="'wizards:notification_step_title' | i18next"
      [valid]="FormModel?.notificationStep?.valid">
      <mbs-notifications-step
        [notification]="mainService.planNotification"
        [(ngModel)]="FormModel.notificationStep"
        (notificationChange)="notificationChangeHandler($event)"></mbs-notifications-step>
    </mbs-wizard-step>
  }
</mbs-wizard>
